import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { isUndefined, omitBy } from "lodash-es";
import { Observable } from "rxjs";
import { UserNotify } from "src/app/support/notify-decorator";
import { PageRequest } from "src/app/support/page-request";
import { PaginatedResult } from "src/app/support/paginated-result";
import { environment } from "src/environments/environment";
import { Group, GroupLight } from "../models/group/group";
import { GroupCreate } from "../models/group/group.create";
import { GroupLoad } from "../models/group/group.load";
import { GroupUpdate } from "../models/group/group.update";
import { map } from "rxjs/operators";

@Injectable()
export class GroupBackend {
  private readonly http = inject(HttpClient);

  load(request: GroupLoad): Observable<Group> {
    return this.http.get<Group>(
      `${environment.snoots.api.iam}/groups/${request.id}`
    );
  }

  loadLight(id: string): Observable<GroupLight> {
    return this.http.get<GroupLight>(
      `${environment.snoots.api.iam}/groups/${id}`,
      {
        params: {
          light: true
        }
      }
    );
  }

  list(request: PageRequest): Observable<PaginatedResult<Group>> {
    return this.http.get<PaginatedResult<Group>>(
      `${environment.snoots.api.iam}/groups`,
      {
        params: omitBy(
          {
            p: request.page,
            s: request.pageSize,
            ...request.filterValues
          },
          isUndefined
        )
      }
    );
  }

  listLight(request: PageRequest): Observable<PaginatedResult<GroupLight>> {
    return this.http.get<PaginatedResult<GroupLight>>(
      `${environment.snoots.api.iam}/groups`,
      {
        params: omitBy(
          {
            p: request.page,
            s: request.pageSize,
            ...request.filterValues,
            light: true
          },
          isUndefined
        )
      }
    );
  }

  listAll(): Observable<Group[]> {
    return this.list({
      page: 1,
      pageSize: 10000
    }).pipe(map((response) => response.docs));
  }

  @UserNotify({
    successMessage: marker("Gruppo creato"),
    errorMessage: marker("Impossibile creare il gruppo")
  })
  create(data: GroupCreate): Observable<string> {
    return this.http.post<string>(`${environment.snoots.api.iam}/groups`, data);
  }

  @UserNotify({
    successMessage: marker("Gruppo aggiornato"),
    errorMessage: marker("Impossibile aggiornare il gruppo")
  })
  update(request: GroupUpdate, id: string): Observable<string> {
    return this.http.patch<string>(
      `${environment.snoots.api.iam}/groups/${id}`,
      request
    );
  }

  @UserNotify({
    successMessage: marker("Gruppo cancellato"),
    errorMessage: marker(
      "Non è stato possibile cancellare il gruppo selezionato"
    )
  })
  delete(id: string): Observable<string> {
    return this.http.delete<string>(
      `${environment.snoots.api.iam}/groups/${id}`
    );
  }
}
